import React, { useRef, useState, useCallback, useEffect } from 'react';
import {
  ModalWrap,
  ModalBox,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalBackground,
} from './styled/CommonEventModalStyled';

const imgURL = '/images';

type setIsOpenModal = React.Dispatch<React.SetStateAction<boolean>>;

interface CloseButtonProps {
  setIsOpenModal: setIsOpenModal;
}

interface CommonEventModalProps {
  isOpenModal: boolean;
  setIsOpenModal: setIsOpenModal;
  bodyChildren: React.ReactNode;
  footerChildren: React.ReactNode;
}

const CloseButton = ({ setIsOpenModal }: CloseButtonProps) => {
  return (
    <button className="close-button" onClick={() => setIsOpenModal(false)}>
      <img src={`${imgURL}/icon_close.png`} alt="닫기" />
    </button>
  );
};

const CommonEventModal = ({ bodyChildren, footerChildren, isOpenModal, setIsOpenModal }: CommonEventModalProps) => {
  const [isTall, setIsTall] = useState(false);
  const modalBoxRef = useRef<HTMLDivElement>(null);

  const cancelHandler = useCallback(() => {
    setIsOpenModal(false);
  }, [setIsOpenModal]);

  useEffect(() => {
    if (modalBoxRef.current) {
      setIsTall(modalBoxRef.current.offsetHeight > 353);
    }
  }, [isOpenModal, bodyChildren, footerChildren]);

  return (
    <>
      <ModalWrap>
        <ModalBox ref={modalBoxRef} isClose={isOpenModal}>
          <ModalHeader>
            <CloseButton setIsOpenModal={setIsOpenModal} />
          </ModalHeader>
          <ModalBody>{bodyChildren}</ModalBody>

          <ModalFooter isTall={isTall}>
            <div className="modal-footer">{footerChildren}</div>
          </ModalFooter>
        </ModalBox>
        <ModalBackground isClose={isOpenModal} onClick={cancelHandler} />
      </ModalWrap>
    </>
  );
};

export default CommonEventModal;
